import styled from 'styled-components';

export const StyledLanguagePicker = styled.div`
    owc-button {
        /* OWC-OVERRIDE: mute the language label. owc-button paints its label colour on the
           internal content wrapper in v7.6.0; the host colour does not cascade through, and
           there is no label-colour prop. */
        .owc-button__content-wrapper {
            color: var(--one-color-gray-500);
        }
    }

    owc-popover {
        max-height: 640px;
        overflow: auto;

        owc-input {
            margin: 1rem;
        }

        owc-list-item.language-selected {
            > div {
                background-color: var(--one-color-interaction-active-brand-lower);
            }
        }
    }
`;
